























































































































import { Prop, Component, Vue, Watch } from 'vue-property-decorator'
import GroupService from '@/services/GroupService'
import GroupMemberService from '@/services/GroupMemberService'
import { ERR_API_KEY } from '@/constants'

/**
 * f2-304a
 * f2-304c
 * グループ メンバー招待 知人の選択・確認
 * グループ メンバー招待他グループから選択・確認
 */
@Component
export default class InviteConfirm extends Vue {
  @Prop({ default: false }) isInviteByMail!: boolean
  @Prop({ default: [] }) mails!: string[]
  @Prop({ default: [] }) private userIds!: number[]
  private userUniqueUrl: string = ''
  mailTitle: string = ''
  mailContent: string = ''
  infoMess: string = ''
  private err_message_default = 'common.message.invite_fail'
  private mailContentObject: { new_user: string; user_active: string } = {
    new_user: '',
    user_active: ''
  }

  created() {
    this.getDefaultMail()
  }

  @Watch('isInviteByMail')
  onInviteTypeChange() {
    this.mailContent = this.isInviteByMail
      ? this.mailContentObject.new_user
      : this.mailContentObject.user_active
  }

  getDefaultMail() {
    this.userUniqueUrl = `${window.location.origin}/register?type=1&url=<INVITE_MEMBER_TOKEN>`
    GroupService.getDefaultMailContent(this.$route.params.groupId)
      .then(res => {
        if (res.status === 200) {
          this.mailTitle = res.data.title
          this.userUniqueUrl = res.data.invite_link
          this.mailContentObject = res.data.content
          this.mailContent = this.mailContentObject.user_active
        }
      })
      .catch(err => {
        this.$bvModal.show('modal-error-invite-confirm')
      })
  }

  sendMails() {
    this.$blockui.show()
    if (this.isInviteByMail) {
      GroupMemberService.sendInviteToUser({
        mails: this.mails,
        group_id: Number(this.$route.params.groupId),
        title: this.mailTitle,
        content: this.mailContent,
        invite_link: this.userUniqueUrl
      })
        .then(res => {
          if (res.status === 200) this.modalSuccess()
        })
        .catch(err => {
          if (
            [
              ERR_API_KEY.INVALID_MEMBER_IN_INVITE_LIST,
              ERR_API_KEY.GROUP_NOT_FOUND_OR_STOPPED,
              ERR_API_KEY.USER_NOT_BE_LONG_TO_COMPANY,
              ERR_API_KEY.USER_NOT_BELONG_TO_COMPANY,
              ERR_API_KEY.ERROR_MAX_REGISTERED_USER
            ].includes(err.response.data.message)
          ) {
            this.modalError(`common.message.${err.response.data.message}`)
          } else {
            this.modalError(this.err_message_default)
          }
        })
        .finally(() => this.$blockui.hide())
    } else {
      GroupMemberService.sendInviteToUser({
        ids: this.userIds,
        group_id: Number(this.$route.params.groupId),
        title: this.mailTitle,
        content: this.mailContent,
        invite_link: this.userUniqueUrl
      })
        .then(res => {
          if (res.status === 200) this.modalSuccess()
        })
        .catch(err => {
          console.log(err.response)
          if (
            [
              ERR_API_KEY.INVALID_MEMBER_IN_INVITE_LIST,
              ERR_API_KEY.GROUP_NOT_FOUND_OR_STOPPED,
              ERR_API_KEY.USER_NOT_BE_LONG_TO_COMPANY,
              ERR_API_KEY.USER_NOT_BELONG_TO_COMPANY,
              ERR_API_KEY.ERROR_MAX_REGISTERED_USER
            ].includes(err.response.data.message)
          ) {
            this.modalError(`common.message.${err.response.data.message}`)
          } else {
            this.modalError(this.err_message_default)
          }
        })
        .finally(() => this.$blockui.hide())
    }
  }

  modalSuccess() {
    this.$bvModal.show('modal-success')
    this.infoMess = String(this.$t('common.message.invited'))
  }

  modalError(err_message: string) {
    this.$bvModal.show('modal-error')
    this.infoMess = String(this.$t(err_message))
  }

  jumpToInviteAuth() {
    this.$router.push({ name: 'group-members-qr-code-invite-auth' })
  }
}
